import React, {Component} from 'react';
import Dragula from 'react-dragula';
import Category from './Category'
import AddNewCategory from './AddNewCategory'
import AllTwitterHandles from './AllTwitterHandles'
import {NoCategories} from './NoCategories'

export default class Categories extends Component {

    constructor(props) {
        super(props);
        this.containers = [];
        this.drake = Dragula({
            moves: function (el, source, handle, sibling) {
                return el.classList.contains("moveableElement");
            },
            accepts: function (el, target, source, sibling) {
                return sibling !== null && sibling.classList.contains("acceptableElement");
            }
        });        
    }
    
    fetchTwitterHandles() {
        let allHandles = this.props.categories
            .map((cat) => cat.links)
            .reduce((a, b) => {
                return a.concat(b)
            }, [])
            .filter((link) => link.twitterHandle)
            .map((link) => "@" + link.twitterHandle)
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))

            return Array.from(new Set(allHandles)).join(" ")
    }

    dragulaDecorator = (componentBackingInstance) => {
        if (componentBackingInstance) {
            // this.containers.push(componentBackingInstance)
            this.drake.containers.push(componentBackingInstance);
        }
    }
    
    componentDidMount() {
        this.drake.on('drop', this.handleDrop);
    }
    
    handleDrop = (el, target, source, sibling) => {
        let links = this.props.categories
            .map((cat) => cat.links)
            .reduce((a, b) => {
                    return a.concat(b)
                }, [])
            .reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {});

        let category = this.props.categories.find((category) => {
            return category.id === parseInt(target.id.replace("cat", ""))
        });
        
        let elements = [...target.getElementsByClassName("moveableElement")];
        let targetLinks = elements.map((x) => x.id)
            .map((x) => links[x]);

        category.links = targetLinks;

        this.props.http.updateCategory(category, this.props.refreshCategories);
        this.drake.cancel(true);
}


render() {
        return (
            <table className="table">
                { this.props.categories == null || this.props.categories.length === 0 ? (
                        <NoCategories/>
                    ) : (
                        this.props.categories.map(category =>
                            <Category key={category.id}
                                      http={this.props.http}
                                      refreshLinks={this.props.refreshCategories}
                                      dragulaDecorator={this.dragulaDecorator}
                                      {...category}/>
                        )
                    )
                }
                <AddNewCategory addCategory={this.props.http.addCategory} refreshLinks={this.props.refreshCategories}/>
                <AllTwitterHandles handles={this.fetchTwitterHandles()}/>
            </table>
        )
    }
}

Categories.propTypes = {
    http: React.PropTypes.object.isRequired,
    refreshCategories: React.PropTypes.func.isRequired,
    categories: React.PropTypes.array
};



// WEBPACK FOOTER //
// ./src/dashboard/categories/Categories.js